import React from 'react';
import "./PricingPage.css"

import Carousel from "react-elastic-carousel";
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';


const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 1, itemsToScroll: 1 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 }
  ];


//   {
//     name: "Minivan",
//     image: require("../assets/vehicles/araclar-14.svg").default,
//     price: "Baz fiyat 150TL + 300TL/saat + Kilometre bazında benzin fiyatlandırması",
//     weightLimit: "500 kg",
//     sizeLimit:"2 x 1.6 x 1.2 m",
//     waypointFee: 75,
// },
  
const pricings =[
    {
        name: "Motorsiklet",
        image: require("../assets/vehicles/araclar-13.svg").default,
        price: "Baz fiyat 25TL + 120TL/saat + Kilometre bazında benzin fiyatlandırması ",
        weightLimit: "5 kg",
        sizeLimit: "35 x 25 x 12 cm",
        waypointFee: 12.5,
    },{
        name: "Doblo",
        image: require("../assets/vehicles/araclar-10.svg").default,
        price :"Baz fiyat 150TL + 250TL/saat + Kilometre bazında benzin fiyatlandırması",
        weightLimit: "200 kg",
        sizeLimit:"1.5 x 1.5 x 1.2 m",
        waypointFee: 60,
    },{
        name: "Panelvan",
        image: require("../assets/vehicles/araclar-09.svg").default,
        price: "Baz fiyat 300TL + 350TL/saat + Kilometre bazında benzin fiyatlandırması",
        weightLimit: "1000 kg",
        sizeLimit:"2.5 x 1.7 x 1.5 m",
        waypointFee: 150,
    },{
        name: "Kamyonet",
        image: require("../assets/vehicles/araclar-15.svg").default,
        price: "Baz fiyat 500TL + 400TL/saat + Kilometre bazında benzin fiyatlandırması",
        weightLimit: "2500 kg",
        sizeLimit:"3 x 1.8 x 2 m",
        waypointFee: 250,
    }
]

var bridges = [{
    t:"15 Tem. Köprüsü",
    price: [3.25, 10.75,23.25,0,0]
},
{
    t:"F.S.M.Köprüsü",
    price: [3.25, 10.75,23.25,23.25,23.25]
},
{
    t:"Y.S.S Köprüsü",
    price: [25.50, 54,81,81,81]
},
{
    t:"Avrasya Tüneli",
    price: [20.70,80,0,0,0]
}];
export default class PricingPage extends React.Component {


    constructor() {
        super();


        
    }
    render() {

        
        return <div><NavBar /><div style={{display:"flex", alignItems:"center",flexDirection:"column",paddingTop:50}}>
            <p style={{fontSize:32, marginTop:50, marginBottom:40}}>Fiyatlandırma</p>
<div style={{display:"flex",width:"100%", maxWidth:1140, paddingBottom:100, overflowX:"hidden"}}>
    <div style={{marginTop:210}}>
        <TableRow title={"Fiyat:"}  height={118} />
        <TableRow title={"Ek Adres:"} height={69} />
        <TableRow title={"Ağırlık Limiti:"} height={69} />
        <TableRow title={"Boyut Limiti:"} height={69} />

        {bridges.map((x,i) => <TableRow key={i} title={x.t+":"} last={i+1 == bridges.length} height={69} />)}
    </div>
           <Carousel  pagination={false} showEmptySlots={false} breakPoints={breakPoints}>
          {pricings.map((item,i) => (
            
            <div key={i} style={{justifyContent:"center", display:"flex", flexDirection:"column", cursor:"grab", paddingLeft:20, paddingRight:20}}>
                

                <div style={{height:160, justifyContent:"center", alignItems:"flex-end",display:"flex", paddingBottom:10}}>
                <img src={item.image} style={{height:100, userSelect:"none", pointerEvents:"none", maxWidth:200}} />
                </div>
                <p style={{fontSize:24, height:65, fontWeight: 600, padding: "0px 10px", textAlign:"center", userSelect:"none"}}>{item.name}</p>
                <p style={{textAlign:"center", userSelect:"none",fontWeight:700, color:"#3C3C3B",height:90}}>{item.price}</p>
                <p style={{textAlign:"center", color:"#3c3c3b",fontSize:16, marginTop:37}}>{item.waypointFee}TL</p>
                <p style={{textAlign:"center", color:"#3c3c3b",fontSize:16, marginTop:53}}>{item.weightLimit}</p>
                <p style={{textAlign:"center", color:"#3c3c3b",fontSize:16, marginTop:46}}>{item.sizeLimit}</p>
                {bridges.map((x,ix) => <p key={ix} style={{textAlign:"center", color:"#3c3c3b",fontSize:16, marginTop:52}}>{x.price[i] != 0?x.price[i]+"TL":"-"}</p>)}
                </div>
          ))}
        </Carousel>

        </div>
            
            <Footer />
        </div></div>
    }
}

const TableRow = (props) => {
    return <div style={{height: props.height, display:"flex", flexDirection:"column", justifyContent:"center", position:"relative"}}>
        <div style={{position:"absolute", left:0,top:0, width:1140, height:1, backgroundColor:"#D8D8D8", overflowX:"hidden"}}></div>
        <p style={{whiteSpace:"nowrap"}}>{props.title}</p>
        {props.last && <div style={{position:"absolute", left:0,bottom:0, width:1140, height:1, backgroundColor:"#D8D8D8", overflowX:"hidden"}}></div>}
    </div>
}


